export const setDropboxAuthSuccess = (value) => ({
  type: "SET_DROPBOX_AUTH_SUCCESS",
  payload: value,
});

export const setDropboxEventId = (eventId) => ({
  type: 'SET_DROPBOX_EVENT_ID',
  payload: eventId,
});
